import Axios from 'axios';

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URI
});

export default axios;
